import { render, staticRenderFns } from "./BankComponent.vue?vue&type=template&id=8f32d874"
import script from "./BankComponent.vue?vue&type=script&lang=js"
export * from "./BankComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports